import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './SlickSlider.less';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

function SampleNextArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <RightOutlined style={{ fontSize: '32px', color: 'grey' }} />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <LeftOutlined style={{ fontSize: '32px', color: 'grey' }} />
    </div>
  );
}

export default function SlickSlider(props) {
  const { isSmallSlides } = props;
  const settings = {
    className: 'center',
    centerMode: true,
    infinite: true,
    centerPadding: '0',
    slidesToShow: isSmallSlides ? 1 : 3,
    speed: 1000,
    dots: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    dotsClass: 'slick-dots-new',
  };
  const { children } = props;
  return (
    <div className='slick-slider-wrapper'>
      <Slider {...settings}>{children}</Slider>
    </div>
  );
}
SlickSlider.propTypes = {
  children: PropTypes.array.isRequired,
};
